<template>
    <basic-container>
        <avue-crud :option="option"
                   :table-loading="loading"
                   :data="data"
                   :page="page"
                   :permission="permissionList"
                   :before-open="beforeOpen"
                   v-model="form"
                   ref="crud"
                   @row-update="rowUpdate"
                   @row-save="rowSave"
                   @row-del="rowDel"
                   @search-change="searchChange"
                   @search-reset="searchReset"
                   @selection-change="selectionChange"
                   @current-change="currentChange"
                   @size-change="sizeChange"
                   @refresh-change="onLoad"
                   @on-load="onLoad">
          <template slot-scope="scope" slot="menu">
            <el-button type="text"
                       size="small"
                       icon="el-icon-edit"
                       v-if="permission.elevatoralarm_handle"
                       @click="openHandleDialog(scope.row)">处理
            </el-button>
          </template>
            <template slot="menuLeft">
                <el-button type="danger"
                           size="small"
                           icon="el-icon-delete"
                           plain
                           v-if="permission.elevatoralarm_delete"
                           @click="handleDelete">删 除
                </el-button>
            </template>
        </avue-crud>
      <el-dialog
        title="处理"
        append-to-body
        :visible.sync="handleDialogFlag"
        :modal-append-to-body="false"
        width="60%"
      >
        <div class="el-property-dialog-div">
          <avue-form
            ref="handleFormRef"
            v-model="handleForm"
            :option="handleOption"
            @submit="handleSubmit"
          >
          <template slot-scope="scope" slot="menuForm">
              <el-button @click="quitHandleDialog">取消</el-button>
            </template>
          </avue-form>
        </div>
      </el-dialog>
    </basic-container>
</template>

<script>
    import {add, getDetail, getList, remove, update} from "@/api/v4ward/elevator/elevatoralarm";
    import {mapGetters} from "vuex";
    import handleOption from './elevatoralarm-handle';

    export default {
        data() {
            return {
                form: {},
                query: {},
                loading: true,
                handleDialogFlag: false,
                handleForm: {
                  id: '',
                },
                handleOption: handleOption,
                page: {
                    pageSize: 10,
                    currentPage: 1,
                    total: 0
                },
                selectionList: [],
                option: {
                    height: 'auto',
                    calcHeight: 30,
                    tip: false,
                    searchShow: true,
                    searchMenuSpan: 6,
                    border: true,
                    index: true,
                    indexLabel: '序号',
                    viewBtn: true,
                    selection: false,
                    dialogClickModal: false,
                    column: [
                                                                                    {
                                    label: "主键ID",
                                    prop: "id",
                                    editDisplay: false,
                                    addDisplay: false,
                                    viewDisplay: false,
                                    hide: true,
                                    rules: [{
                                        required: true,
                                        message: "请输入ID",
                                        trigger: "change"
                                    }]
                                },
                                {
                                    label: "电梯id",
                                    prop: "elevatorId",
                                    editDisplay: false,
                                    viewDisplay: false,
                                    hide: true,
                                    rules: [{
                                        required: true,
                                        message: "请输入电梯id",
                                        trigger: "change"
                                    }]
                                },
                                {
                                  label: "小区名称",
                                  prop: 'communityId',
                                  type: 'select',
                                  dicUrl: 'api/base/property/getCommunityTree',
                                  props: { label: 'roomName', value: 'id' },
                                  search: true,
                                  maxlength: 100,
                                  rules: [{
                                    required: true,
                                    message: "请输入小区名称",
                                    trigger: "change"
                                  }]
                                },
                                {
                                  label: "楼栋名称",
                                  prop: "buildingName",
                                  maxlength: 100,
                                  rules: [{
                                    required: true,
                                    message: "请输入楼栋名称",
                                    trigger: "change"
                                  }]
                                },
                                {
                                  label: "电梯名称",
                                  prop: "elevatorName",
                                  maxlength: 100,
                                  rules: [{
                                    required: true,
                                    message: "请输入电梯名称",
                                    trigger: "change"
                                  }]
                                },
                                {
                                    label: "告警类型",
                                    prop: "alarmType",
                                    type: "select",
                                    dicUrl: '/api/blade-system/dict/dictionary?code=elevator_alarm_type',
                                    props: {
                                      label: "dictValue",
                                      value: "dictKey",
                                    },
                                    rules: [{
                                        required: true,
                                        message: "请输入警告类型",
                                        trigger: "change"
                                    }]
                                },
                                 {
                                    label: "告警内容",
                                    prop: "alarmContent",
                                    rules: [{
                                        required: true,
                                        message: "请输入警告内容",
                                        trigger: "change"
                                    }]
                                },
                                {
                                    label: "告警日期",
                                    prop: "dateRange",
                                    search: true,
                                    searchSpan: 10,
                                    type: 'daterange',
                                    format: 'yyyy-MM-dd',
                                    valueFormat: 'yyyy-MM-dd',
                                    editDisplay: false,
                                    addDisplay: false,
                                    viewDisplay: false,
                                    hide: true,
                                    rules: [{
                                        required: true,
                                        message: "请选择告警日期",
                                        trigger: "change"
                                    }]
                                },
                              {
                                label: "告警时间",
                                prop: "alarmTime",
                                width: 150,
                                type: 'datetime',
                                format: 'yyyy-MM-dd HH:mm:ss',
                                valueFormat: 'yyyy-MM-dd HH:mm:ss',
                                rules: [{
                                  required: true,
                                  message: "请输入警告时间",
                                  trigger: "change"
                                }]
                              },

                                                                                                                {
                                     label: "通知方式",
                                     prop: "notifyType",
                                     type: "select",
                                     dicUrl: "/api/blade-system/dict/dictionary?code=elevator_alarm_notify_type",
                                     props: {
                                        label: "dictValue",
                                        value: "dictKey",
                                       },
                                    rules: [{
                                        required: true,
                                        message: "请输入通知方式",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "处理状态",
                                    prop: "handleFlag",
                                    type: "select",
                                    dicData: [
                                      { label: '未处理', value: '0' },
                                      { label: '已处理', value: '1' },
                                    ],
                                    rules: [{
                                        required: true,
                                        message: "请输入处理状态",
                                        trigger: "blur"
                                    }]
                                },
                                                                                                                {
                                    label: "处理内容",
                                    prop: "handleDesc",
                                    span:24,
                                    type: 'textarea',
                                    hide: true,
                                    rules: [{
                                        required: true,
                                        message: "请输入处理内容",
                                        trigger: "change"
                                    }]
                                },
                    ]
                },
                data: []
            };
        },
        computed: {
            ...mapGetters(["permission"]),
            permissionList() {
                return {
                    addBtn: this.vaildData(this.permission.elevatoralarm_add, false),
                    viewBtn: this.vaildData(this.permission.elevatoralarm_view, false),
                    delBtn: this.vaildData(this.permission.elevatoralarm_delete, false),
                    editBtn: this.vaildData(this.permission.elevatoralarm_edit, false)
                };
            },
            ids() {
                let ids = [];
                this.selectionList.forEach(ele => {
                    ids.push(ele.id);
                });
                return ids.join(",");
            }
        },
        methods: {
            rowSave(row, done, loading) {
                add(row).then(() => {
                    this.onLoad();
                    this.$message.success('操作成功!');
                    done();
                }, error => {
                    window.console.log(error);
                    loading();
                });
            },
            rowUpdate(row, index, done, loading) {
                update(row).then(() => {
                    this.onLoad();
                    this.$message.success('操作成功!');
                    done();
                }, error => {
                    window.console.log(error);
                    loading();
                });
            },
           handleSubmit(row,done,loading){
             update(row).then(() => {
               this.onLoad();
               this.$message.success('操作成功!');
               done();
               this.handleDialogFlag = false;
             }, error => {
               window.console.log(error);
               loading();
             });
            },

            rowDel(row) {
                this.$confirm("确定将选择数据删除?", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        return remove({ids: row.id});
                    })
                    .then(() => {
                        this.onLoad();
                        this.$message.success('操作成功!');
                    });
            },
          openHandleDialog(row) {
            if (row.handleFlag === '1') {
              this.$message.warning('该告警已处理');
              return;
            }
            this.handleDialogFlag = true;
            this.handleForm.id = row.id;
            this.handleForm.handleFlag = '1';
            this.handleForm.communityId = row.communityId;
            this.handleForm.buildingName = row.buildingName;
            this.handleForm.elevatorName = row.elevatorName;
            this.handleForm.brand = row.brand;
            this.handleForm.safetyOfficer = row.safetyOfficer;
            this.handleForm.linkPhone = row.linkPhone;
            this.handleForm.alarmType = row.alarmType;
            this.handleForm.alarmTime = row.alarmTime;
            this.handleForm.alarmContent = row.alarmContent;


          },
          quitHandleDialog(form, done) {
            this.handleDialogFlag = false;
            this.$refs.handleFormRef.resetForm();
          },
            handleDelete() {
                if (this.selectionList.length === 0) {
                    this.$message.warning("请选择至少一条数据");
                    return;
                }
                this.$confirm("确定将选择数据删除?", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        return remove({ids: this.ids});
                    })
                    .then(() => {
                        this.onLoad();
                        this.$message.success('操作成功!');
                        this.$refs.crud.toggleSelection();
                    });
            },

            beforeOpen(done, type) {
                /*if (["edit", "view"].includes(type)) {
                    getDetail({id:this.form.id}).then(({data}) => {
                        this.form = data;
                    });
                }*/
                done();
            },
            searchReset() {
                this.query = {};
                this.onLoad();
            },
            searchChange(params, done) {
                this.query = params;
                this.page.currentPage = 1;
                this.onLoad();
                done();
            },
            selectionChange(list) {
                this.selectionList = list;
            },
            selectionClear() {
                this.selectionList = [];
                this.$refs.crud.toggleSelection();
            },
            currentChange(currentPage) {
                this.page.currentPage = currentPage;
            },
            sizeChange(pageSize) {
                this.page.pageSize = pageSize;
            },
            onLoad(page) {

              if (this.query.dateRange) {
                this.query.dateFrom = this.query.dateRange + ' 00:00:00';
                this.query.dateTo = this.query.dateRange + ' 23:59:59';
              }
             //小区没选默认查0条
              if (this.query.communityId===''||this.query.communityId===undefined) {
                this.query.communityId=-1;
              }

                page = page || this.page;
                this.loading = true;
                getList(
                    Object.assign({current: page.currentPage, size: page.pageSize},  this.query)
                ).then(({data}) => {
                    this.page.total = data.total;
                    this.data = data.records;
                    this.loading = false;
                    this.selectionClear();
                });
            }
        }
    };
</script>

<style>
</style>
